<template>
    <div v-if="!currentCompany.brockmeyer_id" class="h-full flex flex-col items-center justify-center gap-16 text-center">
        <div class="space-y-4">
            <h1 class="font-semibold text-28">{{ $t('campaigns.intro.title') }}</h1>
            <p class="max-w-640">{{ $t('campaigns.intro.message') }}</p>
        </div>
        <h2 class="font-semibold text-body">{{ $t('campaigns.intro.form_title') }}</h2>
        <div class="flex items-center gap-12">
            <select-dropdown
                :auto-translate="false"
                class="text-left w-400 mr-4"
                :options="locations"
                :placeholder="$t('campaigns.intro.form_placeholder')"
                v-model="locationId"
                white-background
            />
            <simple-button
                class="ml-4"
                :disabled="!locationId || performingCompanyCreationRequest"
                display="success"
                :loading="performingCompanyCreationRequest"
                look="primary"
                @click="createCompany"
            >
                {{ $t('campaigns.intro.form_button') }}
            </simple-button>
        </div>
    </div>
    <div v-else>
        <router-view/>
    </div>
</template>
<script>
import EarlyAccessBadge from "./EarlyAccessBadge";
import SelectDropdown from "./forms/SelectDropdown";
import SimpleButton from "./ui/SimpleButton";
import Loading from "./ui/Loading";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../state/modules/authentication';
import * as locations from "../services/LocationService";
import Location from "../models/Location";
import {normalizeJson} from "../../shared/helpers";
import * as campaigns from "../services/CampaignService";
import Company from "../models/Company";

export default {
    components: {Loading, SimpleButton, SelectDropdown, EarlyAccessBadge},
    data() {
        return {
            fetchingLocations: false,
            locationId: null,
            performingCompanyCreationRequest: false
        }
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompany']),
        locations() {
            return useRepo(Location).all().map(val => ({
                value: val.id,
                label: val.alias && val.alias[this.locale] ? val.alias[this.locale] : `${val.street}, ${val.postal_code} ${val.city}, ${val.country}`
            }));
        }
    },
    methods: {
        createCompany() {
            this.performingCompanyCreationRequest = true;

            campaigns.createCompany({
                data: {
                    attributes: {
                        location_id: this.locationId
                    }
                }
            }).then(result => {
                return useRepo(Company).save(normalizeJson(result));
            }).finally(() => {
                this.performingCompanyCreationRequest = false;
            })
        }
    },
    mounted() {
        if (!this.currentCompany.brockmeyer_id) {
            // Fetch locations as they need to select one from there
            this.fetchingLocations = true;

            locations.index()
                .then(result => {
                    return useRepo(Location).save(normalizeJson(result.data));
                })
                .then(() => {
                    this.fetchingLocations = false;
                })
        }
    }
}
</script>
